import { useMemo, memo } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { inject, observer } from 'mobx-react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { ACL_ACTION_TYPE } from '../utils/constants'

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const tabConfig = [
  {
    actionType: ACL_ACTION_TYPE.tab_vb_den__INTERNAL_DOCUMENT,
    label: 'Văn bản đến',
    path: '/internal-document/incoming-document',
  },
  {
    actionType: ACL_ACTION_TYPE.tab_vb_di__INTERNAL_DOCUMENT,
    label: 'Văn bản đi',
    path: '/internal-document/outgoing-document',
  },
  {
    actionType: ACL_ACTION_TYPE.tab_phat_hanh_vb__INTERNAL_DOCUMENT,
    label: 'Phát hành văn bản',
    path: '/internal-document/sign-document',
  },
]

const DocumentPage = ({ aclStore }) => {
  const navigate = useNavigate()
  const location = useLocation()

  // Lọc các tab dựa trên quyền truy cập của người dùng
  const availableTabs = tabConfig.filter(tab =>
    aclStore.checkAccessControlAction(tab.actionType)
  )

  // Tìm chỉ số của tab hiện tại dựa vào pathname
  const currentTabIndex = useMemo(() => {
    return availableTabs.findIndex(tab => tab.path === location.pathname)
  }, [location.pathname, availableTabs])

  const handleChange = (_, newValue) => {
    const selectedTab = availableTabs[newValue]
    if (selectedTab) {
      navigate(selectedTab.path)
    }
  }

  return (
    <div className="pl-2 pr-2">
      <Box>
        <Tabs
          value={currentTabIndex}
          onChange={handleChange}
          aria-label="document tabs">
          {availableTabs.map((tab, index) => (
            <Tab
              key={index}
              className="normal-case text-sm font-semibold leading-[15px] mb-[14px] min-h-0"
              label={tab.label}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
      </Box>
    </div>
  )
}

export default memo(inject('aclStore')(observer(DocumentPage)))
